import { Credit } from "../../api/api";
import { createSlice } from "@reduxjs/toolkit";
import { setter, unsetter } from "../utils/setter";

export interface CreditState {
    list : Credit
}

const initialState: CreditState = {list:{level:"ERROR",limit:0,exposure:0,utilization:0}}

export const creditSlice = createSlice({
  name: 'credit',
  initialState,
  reducers: {
    setCredit: setter(initialState, 'list'),
    unsetCredit: unsetter('list')
  }
})
